import type { SeasonConfig, SeasonId } from '../types/content';

/**
 * Manual campaign presets for Kevin's prototype review. Names come from the
 * client's October 14 email. No dates, countdowns or automatic scheduling run here.
 * The confirmed product offer is held in siteConfig; presets only change the name
 * and brand accents. A custom name can be edited independently in the review tool.
 */
const baseTheme = {
  bannerClass: 'bg-champagne text-ink',
  heroPanelClass: 'bg-canvas-deep',
  heroCaptionClass: 'text-ink-muted',
  accentTextClass: 'text-bronze-deep',
  accentRuleClass: 'bg-bronze',
};

const holidayPresets: Array<{ id: SeasonId; label: string }> = [
  { id: 'new-years-day', label: "New Year's Day" },
  { id: 'martin-luther-king-jr-day', label: 'Martin Luther King Jr. Day' },
  { id: 'presidents-day', label: "Presidents' Day" },
  { id: 'memorial-day', label: 'Memorial Day' },
  { id: 'juneteenth', label: 'Juneteenth' },
  { id: 'independence-day', label: 'Independence Day' },
  { id: 'labor-day', label: 'Labor Day' },
  { id: 'columbus-indigenous-peoples-day', label: 'Columbus Day / Indigenous Peoples Day' },
  { id: 'veterans-day', label: 'Veterans Day' },
  { id: 'thanksgiving', label: 'Thanksgiving' },
  { id: 'christmas', label: 'Christmas' },
  { id: 'valentines-day', label: "Valentine's Day" },
  { id: 'st-patricks-day', label: "St. Patrick's Day" },
  { id: 'easter', label: 'Easter' },
  { id: 'mothers-day', label: "Mother's Day" },
  { id: 'fathers-day', label: "Father's Day" },
  { id: 'halloween', label: 'Halloween' },
  { id: 'black-friday', label: 'Black Friday' },
  { id: 'cyber-monday', label: 'Cyber Monday' },
];

function makePreset(id: SeasonId, label: string, campaignName: string): SeasonConfig {
  return {
    id,
    label,
    bannerMessage: campaignName,
    bannerLinkLabel: 'Shop the mask',
    heroEyebrow: campaignName,
    ...baseTheme,
    ...(id === 'black-friday'
      ? {
          bannerClass: 'bg-ink text-champagne',
          heroPanelClass: 'bg-ink',
          heroCaptionClass: 'text-champagne',
          accentTextClass: 'text-ink',
          accentRuleClass: 'bg-ink',
        }
      : {}),
    ...(id === 'christmas'
      ? {
          bannerClass: 'bg-pine text-canvas',
          heroPanelClass: 'bg-pine-soft',
          heroCaptionClass: 'text-pine',
          accentTextClass: 'text-pine',
          accentRuleClass: 'bg-pine',
        }
      : {}),
    // No additional holiday discount or delivery promise is implied by a preset.
    approvedOffer: null,
  };
}

export const seasons: SeasonConfig[] = [
  makePreset('everyday', 'Special offer', 'Special offer'),
  ...holidayPresets.map(({ id, label }) => makePreset(id, label, `${label} Sale`)),
  makePreset('custom', 'Custom event', 'Custom event'),
];

